"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_hook_form_1 = require("react-hook-form");
var FieldErrorMessage_1 = __importDefault(require("./FieldErrorMessage"));
function Radio(_a) {
    var name = _a.name, label = _a.label, values = _a.values, rest = __rest(_a, ["name", "label", "values"]);
    var _b = (0, react_hook_form_1.useFormContext)(), register = _b.register, errors = _b.formState.errors;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { className: "whitespace-nowrap", children: [label, " ", rest.required && "*"] }), values.map(function (value) { return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("input", __assign({}, register(name, {
                        required: rest.required ? __assign({}, rest.required) : false,
                    }), { type: "radio", name: name, id: "", value: value.value })), (0, jsx_runtime_1.jsx)("label", { className: "whitespace-nowrap", children: value.label })] }, value.label)); }), (0, jsx_runtime_1.jsx)(FieldErrorMessage_1.default, { errors: errors, name: name })] }));
}
exports.default = Radio;
